// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__CMDfH","inner":"Footer_inner__3eSAJ","nextIcon":"Footer_nextIcon__2GaRo","innerLeft":"Footer_innerLeft__3ZTmD"};